import CMSRoutes from "./CMSRoutes.js";

const EmployeeRoutes = [...CMSRoutes];
export default EmployeeRoutes;
